import { buildStoreUrl } from '@dukanti/shared';

/** The published store, or null when the slug cannot form an address. */
export function liveStoreUrl(slug: string | null | undefined): string | null {
  if (!slug) return null;
  try {
    return buildStoreUrl(slug);
  } catch {
    return null;
  }
}

/**
 * What the read-only address bar shows: the public address of the store with
 * the path of the page the merchant is on. It is only a display; the frame
 * itself never leaves the canvas document.
 */
export function displayAddress(
  slug: string | null | undefined,
  displayPath: string | null,
): string {
  const path = displayPath ?? '/';
  const base = liveStoreUrl(slug);
  if (base === null) return path;
  try {
    return `${new URL(base).host}${path === '/' ? '' : path}`;
  } catch {
    return path;
  }
}
